import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionFeelYourSkinPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionFeelYourSkin.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionFeelYourSkin.button1'),
          value: 'frustrated',
        },
        {
          text: t('pages.onboarding.questionFeelYourSkin.button2'),
          value: 'meh',
        },
        {
          text: t('pages.onboarding.questionFeelYourSkin.button3'),
          value: 'okay',
        },
        {
          text: t('pages.onboarding.questionFeelYourSkin.button4'),
          value: 'pretty_good',
        },
        {
          text: t('pages.onboarding.questionFeelYourSkin.button5'),
          value: 'curious_to_learn',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
